<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import { AlternativeVehicle, Form } from '~/layers/forms/models'
import { requiredValidator } from '~/utils/validators'

interface Props {
  modelValue: AlternativeVehicle
}

const props = defineProps<Props>()
const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)

const v$ = useValidation(
  () => ({
    year: { required: requiredValidator },
    manufacturer: { required: requiredValidator },
    model: { required: requiredValidator },
    serialNumber: { required: requiredValidator },
    type: { required: requiredValidator },
  }),
  model,
  {
    $scope: Form.alternateVehicle,
    $registerAs: Form.alternateVehicle,
  }
)

const brandRef = ref<string>()
const modelRef = ref<string>()
</script>

<template>
  <FormsGlobalContainer :identifier="Form.alternateVehicle">
    <FormsGlobalTitle
      text="Información adicional"
      icon-class="icon-[ph--info-bold]"
    />

    <InputField
      label="Marca"
      class="md:col-span-3"
      :error="v$.manufacturer?.$error"
      :error-message="v$.manufacturer?.$errors[0]?.$message.toString()"
    >
      <PvSelect
        v-model="brandRef"
        :options="[]"
      />
    </InputField>

    <InputField
      label="Modelo"
      class="md:col-span-3"
      :error="v$.model?.$error"
      :error-message="v$.model?.$errors[0]?.$message.toString()"
    >
      <PvSelect
        v-model="modelRef"
        :options="[]"
      />
    </InputField>

    <InputField
      label="Año"
      class="md:col-span-2"
      :error="v$.year?.$error"
      :error-message="v$.year?.$errors[0]?.$message.toString()"
    >
      <PvInputNumber
        v-model="model.year"
        fluid
      />
    </InputField>

    <InputField
      label="Tipo"
      class="md:col-span-4"
      :error="v$.type?.$error"
      :error-message="v$.type?.$errors[0]?.$message.toString()"
    >
      <PvSelect
        v-model="model.type"
        option-label="label"
        option-value="code"
        :options="AlternativeVehicle.getTypeList()"
      />
    </InputField>

    <InputField
      label="Número serial"
      class="md:col-span-4"
      :error="v$.serialNumber?.$error"
      :error-message="v$.serialNumber?.$errors[0]?.$message.toString()"
    >
      <PvInputText v-model="model.serialNumber" />
    </InputField>

    <FormsGlobalCurrencyInput
      v-model="model.amount"
      :validation-scope="Form.alternateVehicle"
      inputs-class="md:col-span-4"
    />
  </FormsGlobalContainer>
</template>
